import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SiteLayoutComponent } from './layout/site-layout/site-layout.component';
import { AuthGuard } from './_guards';
import { AppLayoutComponent } from './layout/app-layout/app-layout.component';
import { ApiTestComponent } from './features/api-test/api-test.component';
import { RestrictedComponent } from './features/page-not-found/restricted/restricted.component';

const routes: Routes = [
  {
    path: 'main',
    canActivate: [AuthGuard],
    component: AppLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./features/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
      },
      {
        path: 'matches',
        loadChildren: () =>
          import('./features/videoListing/videoListing.module').then(
            (m) => m.VideoListingModule
          ),
        data: { breadcrumb: 'Video', permission: 'list_videolisting' },
      },
      {
        path: 'teams',
        loadChildren: () =>
          import('./features/team/team.module').then(
            (m) => m.TeamListingModule
          ),
        data: { breadcrumb: 'Team', permission: 'list_team' },
      },
      {
        path: 'leagues',
        loadChildren: () =>
          import('./features/leagues/league.module').then(
            (m) => m.LeagueListingModule
          ),
        data: { breadcrumb: 'League', permission: 'list_league' },
      },
      {
        path: 'players',
        loadChildren: () =>
          import('./features/playerListing/playerListing.module').then(
            (m) => m.PlayerListingModule
          ),
        data: { breadcrumb: 'Player', permission: 'list_player' },
      },
      {
        path: 'xml-checker',
        loadChildren: () =>
          import('./features/xml-checker/xml-checker.module').then(
            (m) => m.XmlCheckerModule
          ),
        data: { breadcrumb: 'xml-checker', permission: 'list_category' },
      },
      {
        path: 'basket-xml-checker',
        loadChildren: () =>
          import('./features/xml-checker/xml-checker.module').then(
            (m) => m.XmlCheckerModule
          ),
        data: { breadcrumb: 'xml-checker', permission: 'list_category' },
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./features/users/users.module').then((m) => m.UsersModule),
        data: { breadcrumb: 'User', permission: 'list_user' },
      },
      {
        path: 'meta-data',
        loadChildren: () =>
          import('./features/metaData/Uploader/metaData-uploader.module').then(
            (m) => m.MetaDataModule
          ),
        data: { breadcrumb: 'MetaData', permission: 'list_metadatauploader' },
      },
      {
        path: 'meta-data/generate',
        loadChildren: () =>
          import('./features/metaData/Generator/metaDataGenerator.module').then(
            (m) => m.MetaDataGeneratorModule
          ),
        data: { breadcrumb: 'MetaDataListing', permission: 'list_metadatagenerator' },
      },
      {
        path: 'clubs',
        loadChildren: () =>
          import('./features/club/club.module').then(
            (m) => m.ClubListingModule
          ),
        data: { breadcrumb: 'MetaDataListing', permission: 'list_clublisting' },
      },
      {
        path: 'actions',
        loadChildren: () =>
          import('./features/action/action.module').then(
            (m) => m.ActionListingModule
          ),
        data: { breadcrumb: 'actions', permission: 'list_action' },
      },
      {
        path: 'filtered-players',
        loadChildren: () =>
          import('./features/filteredPlayers/filteredPlayers.module').then(
            (m) => m.FilterPlayersModule
          ),
        data: { breadcrumb: 'filtered-players', permission: 'list_filterplayer' },
      },
      {
        path: 'stats',
        loadChildren: () =>
          import('./features/stats/stats.module').then((m) => m.StatsModule),
        data: { breadcrumb: 'FilteredPlayers', permission: 'list_stats' },
      },
      {
        path: 'video-files',
        loadChildren: () =>
          import('./features/awsVideo/awsVideo.module').then(
            (m) => m.VideoListModule
          ),
        data: { breadcrumb: 'FilteredPlayers', permission: 'list_videolisting' },
      },
      {
        path: 'encoded-videos',
        loadChildren: () =>
          import('./features/encodeVideo/encodeVideo.module').then(
            (m) => m.JobListModule
          ),
        data: { breadcrumb: 'FilteredPlayers', permission: 'list_awsjobs' },
      },
      {
        path: 'fixtures',
        loadChildren: () =>
          import('./features/fixtures/fixtures.module').then(
            (m) => m.FixtureListingModule
          ),
        data: { breadcrumb: 'fixture', permission: 'list_fixtures' },
      },

      {
        path: 'api/addEvent',
        loadChildren: () =>
          import('./features/addEvent/addEvent.module').then(
            (m) => m.AddModuleModule
          ),
        data: { breadcrumb: 'addEvent', permission: 'list_category' },
      },
      {
        path: 'event_catche',
        loadChildren: () =>
          import('./features/event_catche/event_catche.module').then(
            (m) => m.EventCatcheListingModule
          ),
        data: { breadcrumb: 'catche', permission: 'list_category' },
      },
      {
        path: 'categories',
        loadChildren: () =>
          import('./features/categories/categories.module').then(
            (m) => m.CategoriesModule
          ),
        data: { breadcrumb: 'Category', permission: 'list_category' },
      },
      {
        path: 'brand',
        loadChildren: () =>
          import('./features/brand/brand.module').then((m) => m.BrandModule),
        data: { breadcrumb: 'Brand', permission: 'list_brand' },
      },
      {
        path: 'products',
        loadChildren: () =>
          import('./features/products/products.module').then(
            (m) => m.ProductsModule
          ),
        data: { breadcrumb: 'Product', permission: 'list_product' },
      },
      {
        path: 'roles',
        loadChildren: () =>
          import('./features/roles/roles.module').then((m) => m.RolesModule),
        data: { breadcrumb: 'Roles', permission: 'list_roles' },
      },
      {
        path: 'permissions',
        loadChildren: () =>
          import('./features/capabilities/capabilities.module').then(
            (m) => m.CapabilitiesModule
          ),
        data: {
          breadcrumb: 'Capabilities',
          permission: 'list_capabilities',
        },
      },
      {
        path: 'email',
        loadChildren: () =>
          import('./features/resources/email/email.module').then(
            (m) => m.EmailModule
          ),
        data: { breadcrumb: 'Email', permission: 'list_systememails' },
      },
      {
        path: 'pages',
        loadChildren: () =>
          import('./features/resources/pages/pages.module').then(
            (m) => m.PagesModule
          ),
        data: { breadcrumb: 'Static Page', permission: 'list_page' },
      },
      {
        path: 'faq',
        loadChildren: () =>
          import('./features/faq/faq.module').then((m) => m.FaqModule),
        data: { breadcrumb: 'FAQs', permission: 'list_faq' },
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./features/settings/settings.module').then(
            (m) => m.SettingsModule
          ),
        data: { breadcrumb: 'Settings', permission: 'list_setting' },
      },
      {
        path: 'syncing-tool',
        loadChildren: () =>
          import('./features/syncing-tool/syncing.module').then(
            (m) => m.SyncingToolModule
          ),
        data: { breadcrumb: 'syncing-tool', permission: 'list_syncingtool' },
      },
      {
        path: 'configurations',
        loadChildren: () =>
          import('./features/configurations/configurations.module').then(
            (m) => m.ConfigurationsModule
          ),
        data: { breadcrumb: 'configurations', permission: 'list_configuration' },
      },
      {
        path: 'parser',
        loadChildren: () =>
          import('./features/parser-setting/parser-setting.module').then(
            (m) => m.ParserSettingModule
          ),
        data: { breadcrumb: 'parser', permission: 'list_parsersetting' },
      },
      {
        path: 'analytics',
        loadChildren: () =>
          import('./features/analytics/analytics.module').then(
            (m) => m.AnalyticsModule
          ),
        data: { breadcrumb: 'analytics', permission: 'list_analytics' },
      },
      {
        path: 'analytics',
        loadChildren: () =>
          import('./features/google-analytics/analytics.module').then(
            (m) => m.GoogleAnalyticsModule
          ),
        data: { breadcrumb: 'analytics', permission: 'list_summary_analytics' },
      },
      {
        path: 'embed',
        loadChildren: () =>
          import('./features/embed/embed.module').then((m) => m.EmbedModule),
        data: { breadcrumb: 'embed', permission: 'list_embedscript' },
      },
      {
        path: 'whitelist-domain',
        loadChildren: () =>
          import('./features/whitelist-domain/whitelist-domain.module').then(
            (m) => m.WhitelistDomainModule
          ),
        data: { breadcrumb: 'whitelist-domain', permission: 'list_whitelistdomain' },
      },
      {
        path: 'viber-mesenger',
        loadChildren: () =>
          import('./features/viber-messenger/viber-messenger.module').then(
            (m) => m.ViberMessengerModule
          ),
        data: { breadcrumb: 'viber-mesenger', permission: 'list_vibermessenger' },
      },
      {
        path: 'system',
        loadChildren: () =>
          import('./features/system/system.module').then((m) => m.SystemModule),
        data: { breadcrumb: 'system', permission: 'list_systememails' },
      },
      {
        path: 'vidget-library',
        loadChildren: () =>
        import('./features/custom-widgets/custom-widgets.module').then((m) => m.CustomWidgetsModule),
        data: { breadcrumb: 'custom-vidgets', permission: 'list_customvidgets' },
      }
    ],
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
    component: SiteLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./auth/login/login.module').then((m) => m.LoginModule),
      },
    ],
  },
  {
    path: 'SSO',
    component: SiteLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/SSO/SSO.module').then((m) => m.SSOModule),
      },
    ],
  },
  {
    path: 'home',
    component: SiteLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/home/home.module').then((m) => m.HomeModule),
      },
    ],
  },
  {
    path: 'api-test',
    component: ApiTestComponent,
  },
  {
    path: 'restricted',
    component: RestrictedComponent
  },
  {
    path: '**',
    loadChildren: () =>
      import('./features/page-not-found/page-not-found.module').then(
        (m) => m.PageNotFoundModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
